<template>
  <div>
    <div v-for="(alert, i) in alerts" :key="`item-${i}`">
      <!-- <v-hover v-slot:default="{ hover }"> -->
        <v-alert
          elevation="24"
          border="left"
          colored-border
          tile
          color="primary"
          class="ma-0 pa-2"
          style="cursor: pointer !important"
        >
          <template v-slot:prepend>
            <v-badge overlap bordered class="mr-4 ml-2">
              <template v-slot:badge>
                <span>{{ alert.alertIds.length }}</span>
              </template>
              <v-icon icon large>{{ icon(alert) }}</v-icon>
            </v-badge>
          </template>
          <template v-slot:append>
            <div class="pa-2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon                  
                    icon
                    color="red"
                    v-on="on"
                    @click.stop="remove(alert)"
                    >mdi-delete</v-icon
                  >
                </template>
                <span>{{ $t("Delete") }}</span>
              </v-tooltip>
            </div>
          </template>
          <v-row @click="viewDocuments(alert)" dense>
            <v-col dense>
              <span class="font-weight-light">{{ alert.date }}</span>
              <span class="font-weight-bold ml-1"> {{ title(alert) }}</span>
            </v-col>
          </v-row>
          <v-row @click="viewDocuments(alert)" dense>
            <v-col dense>
              {{ description(alert) }}
            </v-col>
          </v-row>
        </v-alert>
      <!-- </v-hover> -->
    </div>
  </div>
</template>
<script>
import AlertType from "@/ecm/variables/AlertType";
import AlertService from "@/services/AlertService";
import SearchType from "@/ecm/variables/SearchType";
import Utils from "@/ecm/common/Utils";

export default {
  props: {
    alerts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    icon(alert) {
      switch (alert.type) {
        case AlertType.ContentType:
          return "mdi-calendar";
        case AlertType.UserGenerated:
          return "mdi-bell";
        case AlertType.FlowStateChange:
          return "mdi-information-outline";
        case AlertType.FlowStateExpired:
          return "mdi-clock";
      }
    },
    color(alert) {
      switch (alert.type) {
        case AlertType.ContentType:
          return "primary";
        case AlertType.UserGenerated:
          return "green";
        case AlertType.FlowStateChange:
          return "yellow";
        case AlertType.FlowStateExpired:
          return "red";
      }
    },
    title(alert) {
      switch (alert.type) {
        case AlertType.ContentType:
          return `${this.$t("ContentTypeAlert")}`;
        case AlertType.UserGenerated:
          return `${this.$t("UserAlert")}`;
        case AlertType.FlowStateChange:
        case AlertType.FlowStateExpired:
          return `${this.$t("FlowAlert")}`;
      }
    },
    description(alert) {
      switch (alert.type) {
        case AlertType.ContentType:
          return `${this.$t("AlertContentTypeDescription")}: ${
            alert.contentTypeName
          }`;
        case AlertType.UserGenerated:
          return `${this.$t("AlertUserGeneratedDescription")}: ${
            alert.contentTypeName
          }`;
        case AlertType.FlowStateChange:
          return `${this.$t("AlertStateChangeDescription")}: ${
            alert.contentTypeName
          }`;
        case AlertType.FlowStateExpired:
          return `${this.$t("AlertStateExpiredDescription")}: ${
            alert.contentTypeName
          }`;
      }
    },
    remove(alert) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          AlertService.removeUserAlert(alert.toDto()).then(() => {
            this.$emit("on-alert-removed");
          });
        }
      });
    },
    viewDocuments(alert) {
      var pattern = {
        searchPattern: alert.type,
        contentTypeIDs: alert.contentTypeIds.join(),
      };
      var route = `/search/${SearchType.Alert}/${encodeURIComponent(
        JSON.stringify(pattern)
      )}`;
      this.$router.push(route);
    },
  },
};
</script>